export default __webpack_public_path__ + "static/media/logo.a494a924.png";